<div class="base-header">
    <div class="header-container">
        <div class="logo">
            <a href="https://www.dodo.com"><img src="assets/img/icons/product-icons/logo.svg" /></a>
        </div>
    </div>
</div>